import { SimpleDashboardContent } from 'features/dashboard/DashboardContent';
import { Outlet } from 'react-router-dom';
import { ClipboardList } from 'lucide-react';
import { GenericViewHeader } from 'back-office/shared/components/GenericViewHeader';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { NsKey } from 'enums/NsKey';

export default function SurveysView() {
  const { t } = useDynamicTranslation([NsKey.Common]);

  return (
    <SimpleDashboardContent>
      <GenericViewHeader
        title={t("SIDEBAR.SURVEYS_MANAGER")}
        icon={ClipboardList}
      />
      <Outlet />
    </SimpleDashboardContent>
  );
}
